// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__PvDHo","invalid":"Input_invalid__YG-Um"};